// @flow
import React from 'react';
import { Row, Col } from 'Components/Grid';
import Link from 'Components/Link';
import DealerModel from 'Stores/DealerModel';
import styles from './styles.scss';
import Icon from 'Components/Icon';

type Props = {
  dealer: DealerModel,
};

class DeactivatedServiceMessage extends React.Component<Props> {
  render() {
    const { dealer, showRedesignedLeadForms } = this.props;
    window.deactivatedServiceMessage = true;

    let whatsappUrl =
      dealer.settings && dealer.settings.whatsappWidget && dealer.settings.whatsappWidget.isActive
        ? dealer.settings.whatsappWidget.whatsappUrl
        : undefined;

    return (
      <div
        style={{
          padding: showRedesignedLeadForms ? '45px 0' : undefined,
        }}
      >
        <Row>
          <Col cols={12}>
            <h2
              id="modal-headline"
              aria-label="Wartungsarbeiten"
              className={styles.deactivatedHeadline}
            >
              Wartungsarbeiten
            </h2>
          </Col>

          <Col cols={12} className={styles.deactivatedText}>
            <p>
              Dieser Service steht Ihnen temporär nicht zur Verfügung. Vielen Dank für Ihr
              Verständnis.
            </p>
            <p>In der Zwischenzeit können Sie uns gerne direkt kontaktieren:</p>
          </Col>

          <Col cols={12}>
            <div className={styles.deactivatedMessageSeparationLine}></div>
          </Col>

          <Col cols={12}>
            <ul className={styles.deactivatedAddress}>
              <li className={styles.deativatedContactRow}>
                <h3 aria-label={dealer.name} className={styles.dealerName}>
                  {dealer.name}
                </h3>
              </li>
              <li className={styles.deativatedContactRow}>
                <span className={styles.iconWrapper}>
                  <Icon name="phone" />
                </span>

                <div className={styles.deativatedContactText}>
                  <Link to={`tel:${dealer.mainContact.phone}`} label={dealer.mainContact.phone} />
                </div>
              </li>
              <li className={styles.deativatedContactRow}>
                <span className={styles.iconWrapper}>
                  <Icon name="mail" />
                </span>

                <div className={styles.deativatedContactText}>
                  <Link
                    to={`mailto:${dealer.mainContact.email}`}
                    label={dealer.mainContact.email}
                  />
                </div>
              </li>

              {whatsappUrl && (
                <li className={styles.deativatedContactRow}>
                  <span className={styles.iconWrapper}>
                    <img
                      role="presentation"
                      className={styles.whatsappIcon}
                      src={`${process.env.ASSET_ENV_HOST}/assets/img/icon_whatsapp_dark_blue.svg`}
                    />
                  </span>

                  <div className={styles.deativatedContactText}>
                    <Link
                      to={whatsappUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      label="WhatsApp Chat starten"
                    />
                  </div>
                </li>
              )}
            </ul>
          </Col>
        </Row>
      </div>
    );
  }
}

export default DeactivatedServiceMessage;
